import { jsxs as l, jsx as r } from "react/jsx-runtime";
const i = ({ progress: e }) => {
  const s = 2 * Math.PI * 14, c = s * (1 - e / 100);
  return /* @__PURE__ */ l("div", { className: "relative h-8 w-8", children: [
    /* @__PURE__ */ r("svg", { className: "h-full w-full", children: /* @__PURE__ */ r(
      "circle",
      {
        cx: "50%",
        cy: "50%",
        r: 14,
        className: "stroke-text-secondary fill-none",
        strokeWidth: "3"
      }
    ) }),
    /* @__PURE__ */ r("svg", { className: "absolute top-0 left-0 h-full w-full", children: /* @__PURE__ */ r(
      "circle",
      {
        cx: "50%",
        cy: "50%",
        r: 14,
        className: "stroke-background-secondary fill-none transition-all duration-300",
        strokeWidth: "3",
        strokeDasharray: s,
        strokeDashoffset: c,
        transform: "rotate(-90 16 16)"
      }
    ) })
  ] });
};
export {
  i as CircularProgress
};
